<script setup>
import { reactive } from 'vue';
import { getPatient } from '../firebase_files/patient_functions';

const state = reactive({
  patient: null,
  patientId: '',
  patientNotFound: false, // toggles err msg for user
})
const emits = defineEmits(['setPatient', 'cancel']);

async function submitPatient() {
  const p = await getPatient(state.patientId);
  if (p) emits('setPatient', p);
  else state.patientNotFound = true;
}
</script>
<template>
  <div class="modal">

    <div class="modal-content" v-on:keyup.enter="submitPatient">
      <div class="modal-top">
        <div class="title">
          <span>Lookup Patient</span>
        </div>
        <div class="close" @click="emits('cancel')">
          <i class="fa fa-times"></i>
        </div>
      </div>
      <div class="form-item">
        <label>Patient ID</label>
        <input v-model="state.patientId">
      </div>
      <div v-if="state.patientNotFound">
        <p id="pat-not-found">Patient not found. Make sure you typed in the ID correctly.</p>
      </div>

      <button @click="submitPatient">Lookup patient</button>

    </div>


  </div>
</template>
<style lang="scss" scoped>
.modal-content {
  width: 50%;
}

#pat-not-found {
  color: red;
}
</style>
